export const wilayas = [
  { id: 1, code: "1", name: "Adrar", name_ar: "أدرار" },
  { id: 2, code: "2", name: "Chlef", name_ar: "الشلف" },
  { id: 3, code: "3", name: "Laghouat", name_ar: "الأغواط" },
  { id: 4, code: "4", name: "Oum El Bouaghi", name_ar: "أم البواقي" },
  { id: 5, code: "5", name: "Batna", name_ar: "باتنة" },
  { id: 6, code: "6", name: "Béjaïa", name_ar: "بجاية" },
  { id: 7, code: "7", name: "Biskra", name_ar: "بسكرة" },
  { id: 8, code: "8", name: "Béchar", name_ar: "بشار" },
  { id: 9, code: "9", name: "Blida", name_ar: "البليدة" },
  { id: 10, code: "10", name: "Bouira", name_ar: "البويرة" },
  { id: 11, code: "11", name: "Tamanrasset", name_ar: "تمنراست" },
  { id: 12, code: "12", name: "Tébessa", name_ar: "تبسة" },
  { id: 13, code: "13", name: "Tlemcen", name_ar: "تلمسان" },
  { id: 14, code: "14", name: "Tiaret", name_ar: "تيارت" },
  { id: 15, code: "15", name: "Tizi Ouzou", name_ar: "تيزي وزو" },
  { id: 16, code: "16", name: "Alger", name_ar: "الجزائر" },
  { id: 17, code: "17", name: "Djelfa", name_ar: "الجلفة" },
  { id: 18, code: "18", name: "Jijel", name_ar: "جيجل" },
  { id: 19, code: "19", name: "Sétif", name_ar: "سطيف" },
  { id: 20, code: "20", name: "Saïda", name_ar: "سعيدة" },
  { id: 21, code: "21", name: "Skikda", name_ar: "سكيكدة" },
  { id: 22, code: "22", name: "Sidi Bel Abbès", name_ar: "سيدي بلعباس" },
  { id: 23, code: "23", name: "Annaba", name_ar: "عنابة" },
  { id: 24, code: "24", name: "Guelma", name_ar: "قالمة" },
  { id: 25, code: "25", name: "Constantine", name_ar: "قسنطينة" },
  { id: 26, code: "26", name: "Médéa", name_ar: "المدية" },
  { id: 27, code: "27", name: "Mostaganem", name_ar: "مستغانم" },
  { id: 28, code: "28", name: "M’Sila", name_ar: "المسيلة" },
  { id: 29, code: "29", name: "Mascara", name_ar: "معسكر" },
  { id: 30, code: "30", name: "Ouargla", name_ar: "ورقلة" },
  { id: 31, code: "31", name: "Oran", name_ar: "وهران" },
  { id: 32, code: "32", name: "El Bayadh", name_ar: "البيض" },
  { id: 33, code: "33", name: "Illizi", name_ar: "إليزي" },
  { id: 34, code: "34", name: "Bordj Bou Arréridj", name_ar: "برج بوعريريج" },
  { id: 35, code: "35", name: "Boumerdès", name_ar: "بومرداس" },
  { id: 36, code: "36", name: "El Tarf", name_ar: "الطارف" },
  { id: 37, code: "37", name: "Tindouf", name_ar: "تندوف" },
  { id: 38, code: "38", name: "Tissemsilt", name_ar: "تيسمسيلت" },
  { id: 39, code: "39", name: "El Oued", name_ar: "الوادي" },
  { id: 40, code: "40", name: "Khenchela", name_ar: "خنشلة" },
  { id: 41, code: "41", name: "Souk Ahras", name_ar: "سوق أهراس" },
  { id: 42, code: "42", name: "Tipaza", name_ar: "تيبازة" },
  { id: 43, code: "43", name: "Mila", name_ar: "ميلة" },
  { id: 44, code: "44", name: "Aïn Defla", name_ar: "عين الدفلى" },
  { id: 45, code: "45", name: "Naâma", name_ar: "النعامة" },
  { id: 46, code: "46", name: "Aïn Témouchent", name_ar: "عين تموشنت" },
  { id: 47, code: "47", name: "Ghardaïa", name_ar: "غرداية" },
  { id: 48, code: "48", name: "Relizane", name_ar: "غليزان" },
  { id: 49, code: "49", name: "Timimoun", name_ar: "تيميمون" },
  { id: 50, code: "50", name: "Bordj Badji Mokhtar", name_ar: "برج باجي مختار" },
  { id: 51, code: "51", name: "Ouled Djellal", name_ar: "أولاد جلال" },
  { id: 52, code: "52", name: "Béni Abbès", name_ar: "بني عباس" },
  { id: 53, code: "53", name: "In Salah", name_ar: "عين صالح" },
  { id: 54, code: "54", name: "In Guezzam", name_ar: "عين قزام" },
  { id: 55, code: "55", name: "Touggourt", name_ar: "تقرت" },
  { id: 56, code: "56", name: "Djanet", name_ar: "جانت" },
  { id: 57, code: "57", name: "El M’Ghair", name_ar: "المغير" },
  { id: 58, code: "58", name: "El Meniaa", name_ar: "المنيعة" }
];